import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import { delete_icon, edit_icon, eye_icon, left_arrow, password_icon, search_icon, toggle_off, toggle_on, user_profile, view_icon } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { admin_list } from '../redux/api/dummyJson';
import CancelIcon from '@mui/icons-material/Cancel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomSearchSelect from '../../components/Searchbox/CustomSearch';
import { useBookingCancelledMutation, useLazyPropertiesBlockedDropQuery, useLazyTotalLocationsListQuery } from '../redux/api/api';
import moment from 'moment';

const Cancelled = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [popup, setPopup] = useState(false);
    const [viewpopup, setViewPopup] = useState(false);
    const [deletePopup, setDeletePopup] = useState(false);
    const [list, setList] = useState([]);
    const [visible, setVisible] = useState(false);
    const [type, setType] = useState();
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");
    const [count, setCount] = useState();
    const [selectedCityId, setSelectedCityId] = useState('');
    const [selectedPropertyId, setSelectedPropertyId] = useState('');
    const [cities, setCities] = useState([]);
    const [properties, setProperties] = useState([]);

    const [fromdate, setFromDate] = useState(moment());
    const [toDate, setToDate] = useState(moment());
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [bookings, setBookings] = useState([])

    console.log("selecc", selectedPropertyId);
    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    // RTK Query
    const [cancelledListApi] = useBookingCancelledMutation();
    const [getCityApi] = useLazyTotalLocationsListQuery();
    const [getPropertyApi] = useLazyPropertiesBlockedDropQuery();


    const getLocations = () => {
        getCityApi()
            .unwrap()
            .then((res) => {
                console.log(res);
                let temp = res?.data?.filter((item) => item?.type == 3);
                setCities(temp);
            })
            .catch((err) => {
                console.error(err);
            });
    };


    const getProperty = () => {
        getPropertyApi()
            .unwrap()
            .then((res) => {
                console.log(res);
                const formattedProperties = res?.data
                setProperties(formattedProperties);


            })
            .catch((err) => {
                console.error(err);
            });
    };

    const bookingCancelledList = (fromdate,
        toDate,
        selectedCityId,
        selectedPropertyId,
        search,
        pageno,) => {
        const formdata = new FormData();
        if (fromdate && toDate) {
            formdata.append('from_date', moment(fromdate).format('YYYY-MM-DD'))
            formdata.append('to_date', moment(toDate).format('YYYY-MM-DD'))
        }
        if (selectedPropertyId) {
            formdata.append('property_id', selectedPropertyId)
        }
        if (selectedCityId) {
            formdata.append('city', selectedCityId)
        }
        if (search) {
            formdata.append('search', search)
        }

        formdata.append('page', pageno)
        formdata.append('per_page', 10)

        setFromDate(fromdate);
        setToDate(toDate);
        setSelectedPropertyId(selectedPropertyId);
        setSelectedCityId(selectedCityId);
        setSearch(search);

        cancelledListApi(formdata)
            .unwrap()
            .then((res) => {
                let temp = []
                res?.data?.map((item, ind) => {
                    let obj = { ...item }
                    obj.current_page = res?.pagination?.current_page
                    temp.push(obj)
                })
                setList(temp);

                let semp = temp?.map((item) => item?.bookings)
                console.log('semp', semp)
                setBookings(semp)

                setPagecount(res?.pagination)
                setCount(res?.pagination?.total)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }


    console.log('lissss', bookings)

    useEffect(() => {
        getLocations()
        getProperty()
        bookingCancelledList(
            fromdate,
            toDate,
            selectedPropertyId,
            selectedCityId,
            search,
            pageno,)
    }, []);




    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },
            {
                Header: "Property ID",
                accessor: "property_id",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/property-view", { state: { data: row.original } })}>{value}</p> </div>
                },
            },
            {
                Header: "Property Name",
                accessor: "name",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/property-view", { state: { data: row.original } })}>{value}</p></div>
                },
            },
            {
                Header: "Owner name",
                accessor: "owner_name",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row.original.owner_id } })}>{value}</p></div>
                },
            },
            {
                Header: "City",
                accessor: "city",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Count",
                accessor: "bookings",
                Cell: ({ value, row }) => {
                    return <p>{value?.length}</p>;
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {rolePermissions?.includes('CAN-VIEW-BOOKINGS') &&
                                    <button
                                        onClick={() => navigate('/cancelled-list', {
                                            state: {
                                                data: list,
                                                bookings: row?.original?.bookings
                                            }
                                        })}
                                        className="cust-btn "
                                    >
                                        <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                    </button>
                                }
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    Bookings - Cancelled
                </h2>
            </div>
            <div>
                <div className='d-flex ac-js gap-2 mt-2'>
                    <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >From Date</label>
                    <div className="w-15">
                        <DatePicker
                            selected={fromdate}
                            onChange={(e) => {
                                bookingCancelledList(
                                    e,
                                    toDate,
                                    selectedCityId,
                                    selectedPropertyId,
                                    search,
                                    1,
                                );
                            }}
                            dateFormat="dd-MM-yyyy"
                            className="input-pop-new ps-2 w-100"
                            placeholderText="From Date"
                            type="date"
                        />
                    </div>
                    <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >To Date</label>
                    <div className='w-15'>
                        <DatePicker
                            type="date"
                            dateFormat="dd-MM-yyyy"
                            className="input-pop-new ps-2 w-100"
                            placeholderText="To Date"
                            selected={toDate}
                            onChange={(e) =>
                                bookingCancelledList(fromdate, e, selectedCityId, selectedPropertyId, search, 1)
                            }
                        />
                    </div>
                    <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap" >Property </label>
                    <CustomSearchSelect
                        options={properties}
                        value={selectedPropertyId}
                        onChange={(value) => {
                            setSelectedPropertyId(value);
                            bookingCancelledList(
                                fromdate,
                                toDate,
                                selectedCityId,
                                value,
                                search,
                                1,
                            );
                        }}
                        placeholder="Select Property"
                        width="200px"
                    />
                    <label className="f2 fs-sm-8 fs-md-12 fs-lg-14 fs-xl-14 fs-xxl-15 primary text-nowrap">
                        Search
                    </label>
                    <div className="search-input ">
                        <input
                            type="text"
                            placeholder="Search"
                            style={{ border: "none", width: "150px" }}
                            value={search}
                            onChange={(e) =>
                                bookingCancelledList(
                                    fromdate,
                                    toDate,
                                    selectedCityId,
                                    selectedPropertyId,
                                    e.target.value,
                                    1,
                                )
                            }
                        />
                        <img src={search_icon} className="search" />
                    </div>
                </div>

                <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
            </div>

        </div>
    )
}

export default Cancelled